<template>
  <div>
    <v-expansion-panels class="progressbar mt-4">
      <v-expansion-panel v-for="(book, i) in books" :key="`book-${book.id}`" class="mb-6">

        <v-expansion-panel-header>
          <v-row align="center" class="spacer" no-gutters>
            <v-col cols="12" lg="3" md="12" sm="12" xs="12"  class="subtitle-1">
              <span class="header my-2" style="font-size: 24px; line-height: 36px">{{
                getProfessionNameById(book.professionId)
              }}</span>
            </v-col>
              <v-col cols="12" lg="3" sm="6"  class="subtitle-1 pl-1 mb-n1">
              <span class="body-2">{{
                (get(book, 'bookStatus.name', '')).toLowerCase() | capitalize
              }} e-bok, skapad {{ book.validTo | date }} (id: {{ book.id }}{{ printApplicationId(get(book, 'education.distanceOrderId', null)) }})</span>
            </v-col>
              <v-col cols="12" lg="6" sm="6" class="subtitle-1 d-flex justify-end">
              <div v-if="book.education && book.education.startDate" class="mb-n1 body-2 mr-4">
                Utbildning påbörjad {{ book.education.startDate | date}} <span v-if="book.company && book.company.name && book.company.id">hos
                <router-link :to="'/companies/' + book.company.id">{{ book.company.name }}</router-link></span>
              </div>
            </v-col>
            <v-col cols="12">
              <progressLinear
                color="#224277"
                class="mt-n1 mb-n2"
                :value="getPercentage(Number(book.bookElementsApprovedCount), Number(book.bookElementsMandatoryCount))"
              ></progressLinear>
            </v-col>
          </v-row>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-row>
            <v-col cols="12" class="px-10 text-right">
              <v-btn v-if="isAdmin" outlined 
                @click="deleteBook(book)"
                :disabled="!canDelete"
                class="mr-4" 
              >
                <v-icon>$sl-delete</v-icon>Radera
              </v-btn>
              <v-btn outlined 
                :disabled="![2,3].includes(get(book, 'bookStatus.id', -1)) || !canUpdate" 
                @click="changeStatus(book)"
              >
                <v-icon>$sl-trafficlights</v-icon>Ändra status
              </v-btn>
              <v-btn v-if="canExtendGU(book)" outlined 
                class="ml-4" 
                @click="extendTime = true"
                :disabled="!canUpdate"
              >
                <v-icon>$sl-edit</v-icon>Förläng tid
              </v-btn>
            </v-col>
            <v-col class="d-flex justify-end px-10">
              <v-btn
                class="elevation"
                color="primary"
                v-if="isAdmin && books.length"
                @click="optionsPopupVisible = true">
                <v-icon class="pr-1">$sl-add</v-icon>
                Lägg till kurs/moment
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="px-4">
              {{ selectedPerson.firstName }} är godkänd i
              {{ book.bookElementsApprovedCount }} av
              {{ book.bookElementsMandatoryCount }} moment.
              <br />
              <i
                >{{ selectedPerson.firstName | filterGenitiveName }} utbildning har pågått
                i {{ getGoingDays(book.createdAt) }}. Den planeras vara slutförd
                {{ getLastDate(book) }} (om
                {{ getLeftDays(getLastDate(book)) }}).
                </i

              >
            </v-col>
          </v-row>

          <!-- Temporary notice text! -->
          <!--
          <v-row>
            <v-col>
              <MessageBox>
                <b>OBS!</b>
                <br />
                <span class="mb-4 mr-5 d-block">
                  Just nu kan det se ut som om du/din lärling är klar med distansutbildningen trots att några eller alla uppdrag inte är gjorda.
                  Vi arbetar med problemet, om du har frågor kan du kontakta BYNs kansli.
                </span>
              </MessageBox>
            </v-col>
          </v-row>
        -->

          <DistanceEducationProviderCourses
            class="mt-6"
            :book="book"
            v-if="book"
            @save="init()"
          />
          <ElementsExpansionPanel
            :elements="book.bookElements"
            :book="book"
            :apprenticeName="selectedPerson.firstName"
          ></ElementsExpansionPanel>"

          <v-dialog v-model="extendTime" max-width="600px">
            <PersonEbooksExtendTimeModal
              :extendTime="extendTime"
              :book="book"
              @close="close()"
            />
          </v-dialog>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div>
      <v-dialog v-model="optionsPopupVisible" max-width="200px" content-class="fixed-bottom-right">
        <v-list class="ma-0 pa-0">
          <v-list-item v-for="(option, index) in options" :key="index">
            <v-list-item-content>
              <v-list-item-title
                data-cy="item"
                @click="
                optionsPopupVisible = false
                elModal = true
                elModalState = option.id">
                  {{ option.label }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-dialog>
    </div>

    <!-- List theoretical/practical elements -->
    <v-dialog v-model="elModal" :max-width="600">
      <PersonEbookElementsModal
        :books="books"
        :visible="elModal"
        :elModalState="elModalState"
        @close="elModal = false" />
    </v-dialog>
  </div>
</template>

<script>
import API from "@/services/api.js";
import { mapGetters, mapActions } from "vuex";
import { RulesMixin, Utilities, CompanyRoles, CanIDo } from "@/components/mixins";
import progressLinear from "@/components/common/ProgressLinear";
import ElementsExpansionPanel from "@/components/ebook/ElementsExpansionPanel";
import DistanceEducationProviderCourses from "@/components/person/DistanceEducationProviderCourses";
import get from "lodash/get";
import find from 'lodash/find'
import PersonEbookElementsModal from '@/components/person/PersonEbookElementsModal/PersonEbookElementsModal.vue';
import PersonEbooksExtendTimeModal from '@/components/person/PersonEbooks/PersonEbooksExtendTimeModal.vue';
const SugarDate = require("sugar/date");
import MessageBox from '@/components/common/MessageBox.vue'

// @group Person
// PersonEbooks component
export default {
  name: "PersonEbooks",

  mixins: [RulesMixin, CompanyRoles, Utilities, CanIDo],

  components: {
    progressLinear,
    ElementsExpansionPanel,
    DistanceEducationProviderCourses,
    PersonEbookElementsModal,
    PersonEbooksExtendTimeModal,
    MessageBox
  },

  data: () => ({
    books: [],
    education: {},
    company: {},
    optionsPopupVisible: false,
    options: [
      { id: 0, label: 'Teoretiska moment' }, 
      { id: 1, label: 'Praktiska moment' }
    ],
    elModal: false,
    elModalState: '',
    extendTime: false,
  }),

  computed: {
    ...mapGetters('currentuser', ['currentUserRole']),
    ...mapGetters("person", ["selectedPerson"]),
    ...mapGetters("basic", ["getProfessionNameById","hasProfessionOrientations"]),
    isAdmin() {
      return this.currentUserRole === 'admin';
    },
    isRegistry() {
      return this.currentUserRole === 'registry';
    },
    canExtendGU() {
      return book => {
        
        if( book.bookStatus.id === 5 ) {
          return false
        }

        if( book.isApprovedByInstructor ) {
          return false
        }

        return true
      }
    }
  },

  asyncComputed: {
    canDelete(){
      return this.canIDo('book', 'delete');
    },
    canUpdate(){
      return this.canIDo('book', 'update');
    }
  },

  created() {
    this.init();
  },

  filters: {
    filterGenitiveName(name) {
      if (name && name.length > 0) {
        if (name.slice(-1) == "s") return name;
      }
      return name + "s";
    },
  },

  watch: {
    elModal: {
      handler(val) {
        if(!val) {
          this.books = []
          this.init()
        }
      }
    }
  },

  methods: {
    get: get,

    printApplicationId(distanceOrderId = null) {
      if ( !distanceOrderId ) return
      return `, anmälan: ${ this.selectedPerson?.distanceOrders?.find(d => d.id === distanceOrderId)?.applicationId }`
    },
    /**
     * @vuese
     * Used to fetch books based related to person id
     * @arg The argument is integer values representing person id
     */
    init() {
      this.books = []
      API.getPersonBooks(this.$route.params.id)
        .then((res) => {
          if (res.data && !res.data.length) {
            return this.books = [];
          }

          if (res.data) {
            let bookObj = {}
            if (this.selectedPerson && this.selectedPerson.books && this.selectedPerson.books.length>0) {
              res.data.forEach(r => {
                bookObj = r
                let found = this.selectedPerson.books.find(b => (b.apprenticeship && b.apprenticeship.id && r.apprenticeshipId && b.apprenticeship.id==r.apprenticeshipId))

                if(found && found.apprenticeship && found.apprenticeship.company) {
                  bookObj.company = found.apprenticeship.company
                }
                this.books.push(r)
              });
            }
          }
        })
        .catch((error) => {
          console.log("Error: " + error);
        });
    },

    getGoingDays(createdAt) {
      createdAt=SugarDate.Date(createdAt).format("{yyyy}-{MM}-{dd}").raw
      if (SugarDate.Date(createdAt).daysAgo() == 1) {
        return SugarDate.Date(createdAt).daysAgo() + " dag";
      } else {
        return SugarDate.Date(createdAt).daysAgo() + " dagar";
      }
    },
    getLastDate(book) {
      if(book.education) {
        return SugarDate.Date(book.education.calculatedEndDate).format("{yyyy}-{MM}-{dd}").raw;
      }

      let isMachineProfession = this.hasProfessionOrientations(book.professionId)
       if (isMachineProfession) {
         return SugarDate.Date(book.createdAt).addMonths(6).format("{yyyy}-{MM}-{dd}").raw;
       } else {
         return SugarDate.Date(book.createdAt).addMonths(12).format("{yyyy}-{MM}-{dd}").raw;
       }

    },
    getLeftDays(lastDate) {
      if (SugarDate.Date(lastDate).daysFromNow() == 1) {
        return SugarDate.Date(lastDate).daysFromNow() + " dag";
      } else {
        return SugarDate.Date(lastDate).daysFromNow() + " dagar";
      }
    },
    async changeStatus(book) {
      const res = await this.$dialog.confirm({
        title: 'Ändra status på e-bok',
        text: `Vill du ändra status på e-boken till ${(book.isActive ? 'INAKTIV' : 'AKTIV')}?`,
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Ändra status', key: true, icon: '$sl-check', outlined: true}
        ]
      })

      if (!res === true) {
        return
      }

      API.setBookStatus(book.id, {data: {isActive: !book.isActive}})
        .then((res) => {
          this.init()
        })
        .catch((error) => {
          this.$events.fire('showError', 'Tyvärr gick det inte att ändra status på e-boken.')
          console.log("Error: " + error);
        });
    },
    async deleteBook(book) {
      const res = await this.$dialog.confirm({
        title: 'Radera e-bok',
        text: 'Vill du ta bort e-boken?',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Radera', key: true, icon: '$sl-check', outlined: true}
        ]
      })

      if (!res === true) {
        return
      }

      try {
        await API.deleteBook(book.id);
        this.init();
      } catch (e) {
        this.$events.fire('showError', get(e, 'response.data.message', 'Kunde inte radera eboken'))
      }
    },

    close() {
      this.extendTime = false
      this.init()
    }
  },
};
</script>

<style lang="scss" scoped></style>
